import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import MultiSelect from 'common/data-entry/MultiSelect/MultiSelect';

import Select from '../../../../../common/data-entry/Select';
import { FRS_LOADED, FRS_READY, FRS_UNINITIALIZED } from '../../reducer';

import { initializeProcessor, setValueProcessor, syncCacheProcessor } from './processors';

export default function StudySingleSiteMultiselect({ uniqKey, state, dispatch, getStudySites }) {
  const { t } = useTranslation();
  const fState = state[uniqKey];
  const fCache = state.cache[uniqKey];
  const status = state.schema[uniqKey].status;
  const { studies, sites, selectedStudy, selectedSites } = fState || {};

  useEffect(() => {
    if (status !== FRS_UNINITIALIZED) {
      return;
    }
    getStudySites().then(function(payload) {
      dispatch({
        type: 'PERFORM',
        processor: initializeProcessor,
        payload: {
          key: uniqKey,
          ...payload
        }
      });
    });
  }, [uniqKey, dispatch, status, getStudySites]);

  useEffect(
    function() {
      if (status !== FRS_LOADED) {
        return;
      }

      dispatch({
        type: 'PERFORM',
        processor: syncCacheProcessor,
        payload: fCache
      });
    },
    [dispatch, uniqKey, status, fCache]
  );

  if (status !== FRS_READY) return null;

  return (
    <>
      <Select
        className="eui-filter-control-study-pcn"
        dataSource={studies}
        value={selectedStudy}
        onChange={function(value) {
          dispatch({
            type: 'PERFORM',
            processor: setValueProcessor,
            payload: {
              key: uniqKey,
              key2: 'Study',
              value: value
            }
          });
        }}
        label={t('study')}
        searchable={true}
        closeOnSelectedOptionClick={false}
        deselectOnSelectedOptionClick={false}
        clearable={true}
        validate={false}
        customFilterFunction={function(e, index, collection, searchString) {
          return `${e.projectCode} ${e.name}`.toLowerCase().includes(searchString);
        }}
        customOptionTemplateFunction={function(e) {
          return (
            <>
              <div className="eui-filter-control-study-pcn-label">{e?.projectCode}</div>
              <div>{e?.name}</div>
            </>
          );
        }}
        customSelectedValueTemplateFunction={function([selectedValue]) {
          if (!selectedValue) {
            return null;
          }
          return (
            <span>
              {selectedValue?.name}{' '}
              <span className="eui-filter-control-study-pcn-label"> ({selectedValue.projectCode})</span>
            </span>
          );
        }}
      />
      <MultiSelect
        data-testid="site-filter"
        label={t('site')}
        disabled={false}
        dataSource={sites}
        onChange={function(values) {
          dispatch({
            type: 'PERFORM',
            processor: setValueProcessor,
            payload: {
              key: uniqKey,
              key2: 'Site',
              value: values
            }
          });
        }}
        value={selectedSites}
        searchable={true}
        clearSearchOnSelection
        validate={false}
      />
    </>
  );
}
